module.exports = __webpack_public_path__ + "assets/img/logo-light2.c0d744d0.png";